<template lang="pug">
    v-col
      v-tooltip(bottom='')
        template(v-slot:activator='{ on }')
            v-btn( v-if='estado_de_cotizacion == "cotizado" ' v-on='on' :to = '{params:{idCotizacion: idCotizacion }}' icon color='secondary'  )
              v-icon(small) fas fa-check
        span No disponible
      v-tooltip(bottom='')
        template(v-slot:activator='{ on }')
            v-btn( v-if='estado_de_cotizacion == "esperando" ' v-on='on' :to = '{params:{idCotizacion: idCotizacion }}' icon color ='secondary' dialog=true ) 
              v-icon(small) fas fa-eye 
        span Cotizar
</template>
<script>
import {mapActions, mapGetters, mapState} from 'vuex'
export default {
  data:()=>({
dialog: false,
  }),
  props:{
    idCotizacion: String,
    estado_de_cotizacion: String,
  },
}
</script>
